import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../components/Loader";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function EditTemplate() {
    const {id} = useParams();
    const API_URL = BASE_URL + "/updatetemplate";
    const navigate = useNavigate();
    const GET_COUNTRY_URL = BASE_URL + "/getcountries";
    const [templates, setTemplate] = useState([]);
    const [countries, setCountry] = useState([]);
    const [loading, setLoading] = useState(true);
    const editorRef = useRef(null);

    const GET_TEMP = BASE_URL+"/gettemplates";
    
    useEffect(() => {
        axios.get(GET_TEMP, {
            headers: {
                "Authorization": apiKey,
                "Content-Type": "application/json"
            }
        })
        .then(
            res => {
                setTemplate(res.data);
                setLoading(false);
            }
        )
        .catch(
            error => {
                console.log("There was an error", error);
            }
        )
    }, [])

    let getTemplate = "";
    let getCountry = "";
    templates
    .filter(template => template.Id == id)
    .map(template => (
        getTemplate = template.Template,
        getCountry = template.Country
    ))

    useEffect(() => {
        if (editorRef.current) {
            editorRef.current.innerHTML = getTemplate;
        }
    }, [getTemplate]);
    // Spam Filter Regex
    const spamRegex = /(spam|free money|buy now|click here|winner|congratulations|lottery|earn money|guaranteed|double your income|order now|no credit check|investment opportunity|unsubscribe|claim prize|opt-out|limited time offer|special promotion|act now|work from home|instant access|miracle|risk-free|make money online|cash bonus|you have been selected)/i;

    useEffect(() => {
        axios.get(GET_COUNTRY_URL, {
            headers: { "Authorization": apiKey, "Content-Type": "application/json" }
        })
        .then(res => {
            setCountry(res.data);
            setLoading(false);
        })
        .catch(error => console.log("There was an error", error));
    }, []);

    const applyFormat = (command) => {
        document.execCommand(command, false, null);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const country = formData.get("country");
        const template = editorRef.current.innerHTML.trim();

        if (!country || !template) {
            toast.error("All fields are required!");
            return;
        }

        // if (spamRegex.test(template)) {
        //     toast.error("Your email template contains spam-related words. Please remove them.");
        //     return;
        // }

        const data = { Country: country, Template: template, Id: id };

        axios.put(API_URL, data, {
            headers: { "Authorization": apiKey, "Content-Type": "application/json" }
        })
        .then(res => {
            navigate("/emails/email-templates");
        })
        .catch(error => console.log(error));
    };

    if (loading) return <Loader />;

    return (
        <div className="container">
            <ToastContainer />
            <h2>Add New Email Template</h2>
            <br />
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-sm-6">
                        <select className="form-control" name="country" required>
                            <option disabled selected>Select Template</option>
                            {countries
                                .filter(country => country.Status === "Active")
                                .map(country => (
                                    <option key={country.Country} value={country.Country} selected={getCountry == country.Country}>
                                        {country.Country}
                                    </option>
                                ))}
                        </select>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-sm-12">
                        {/* Formatting Buttons */}
                        <div className="mb-2">
                            <button type="button" className="btn btn-sm btn-dark mx-1" onClick={() => applyFormat("bold")}>
                                B
                            </button>
                            <button type="button" className="btn btn-sm btn-dark mx-1" onClick={() => applyFormat("italic")}>
                                I
                            </button>
                            <button type="button" className="btn btn-sm btn-dark mx-1" onClick={() => applyFormat("underline")}>
                                U
                            </button>
                        </div>
                        {/* Editable Div for Email Template */}
                        <div
                            ref={editorRef}
                            contentEditable
                            className="form-control"
                            style={{ color: "#000", height: "250px", border: "1px solid #ccc", padding: "10px", overflowY: "auto" }}
                        ></div>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-sm-6">
                        <button className="btn btn-primary">Update Template</button>
                    </div>
                </div>
            </form>
        </div>
    );
}
